export function prettyPrintAndStringifyLargeNumber(val: number) {
  if (typeof val !== 'number' || Number.isNaN(val)) {
    return val?.toString()
  }

  if (val < 1000) return val.toString()
  if (val < 1000000) return `${(val / 1000).toFixed(1)}k`
  if (val < 1000000000) return `${(val / 1000000).toFixed(1)}m`
  return `${(val / 1000000000).toFixed(1)}b`
}
